import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../Context/Context";
import Button from "../../../Custom/Button/Button";

const formatDatum = (datum) => {
  if (!datum) return null;
  const d = new Date(datum);
  if (isNaN(d)) return datum;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}.`;
};

function IDKarticaZaposlen({ zaposlen, handleZatvori }) {
  const { baseUrl } = useGlobalContext();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!zaposlen?.id) return;
    fetch(`${baseUrl}/zaposleni/read_one.php?id=${zaposlen.id}`)
      .then((r) => r.json())
      .then((res) => { if (res.status === 200) setData(res.data); })
      .catch(console.error);
  }, [zaposlen]);

  const handlePrint = () => {
    const fotoUrl = data?.slika ? `${baseUrl.replace("/api", "")}/${data.slika}` : null;

    const html = `<!DOCTYPE html>
<html lang="sr">
<head>
  <meta charset="UTF-8"/>
  <title>ID Картица — ${data?.ime} ${data?.prezime}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Times New Roman', serif; background: #fff; color: #111; }
    @page { size: A4 portrait; margin: 0; }

    .page {
      width: 210mm;
      height: 297mm;
      display: flex;
      flex-direction: column;
      border: 1px solid #000;
    }

    .header {
      background: #fff;
      color: #111;
      padding: 14mm 14mm 10mm;
      display: flex;
      align-items: flex-end;
      gap: 10mm;
      border-bottom: 2px solid #111;
    }

    .foto-wrap {
      width: 45mm;
      height: 55mm;
      border: 1.5px solid #111;
      flex-shrink: 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f5;
    }

    .foto-wrap img { width: 100%; height: 100%; object-fit: cover; }
    .no-foto { color: #aaa; font-size: 13px; text-align: center; padding: 6px; }

    .header-info { flex: 1; padding-bottom: 3mm; }

    .header-label {
      font-size: 11px;
      letter-spacing: 3px;
      text-transform: uppercase;
      color: #666;
      margin-bottom: 3mm;
    }

    .ime-prezime {
      font-size: 36px;
      font-weight: 700;
      line-height: 1.1;
      color: #111;
      margin-bottom: 3mm;
    }

    .radno-mesto { font-size: 17px; color: #444; }

    .body {
      flex: 1;
      padding: 12mm 14mm 8mm;
      display: flex;
      flex-direction: column;
      gap: 8mm;
    }

    .section-title {
      font-size: 11px;
      letter-spacing: 3px;
      text-transform: uppercase;
      color: #111;
      font-weight: 700;
      border-bottom: 1.5px solid #111;
      padding-bottom: 2mm;
      margin-bottom: 4mm;
    }

    .grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4mm 10mm;
    }

    .field { display: flex; flex-direction: column; gap: 1mm; }

    .field-label {
      font-size: 10px;
      letter-spacing: 2px;
      text-transform: uppercase;
      color: #666;
      font-weight: 600;
    }

    .field-value {
      font-size: 16px;
      font-weight: 600;
      color: #111;
      border-bottom: 1px solid #ddd;
      padding-bottom: 2mm;
    }

    .field-value.empty { color: #bbb; font-weight: 400; font-style: italic; }
  </style>
</head>
<body>
<div class="page">

  <div class="header">
    <div class="foto-wrap">
      ${fotoUrl
        ? `<img src="${fotoUrl}" />`
        : `<div class="no-foto">Нема<br/>фотографије</div>`}
    </div>
    <div class="header-info">
      <div class="header-label">Идентификациона картица запосленог</div>
      <div class="ime-prezime">${data?.ime || ""} ${data?.prezime || ""}</div>
      <div class="radno-mesto">${zaposlen?.radnoMesto || "—"}</div>
    </div>
  </div>

  <div class="body">
    <div>
      <div class="section-title">Лични подаци</div>
      <div class="grid">
        <div class="field">
          <div class="field-label">Матични број</div>
          <div class="field-value ${!data?.maticni_broj ? 'empty' : ''}">${data?.maticni_broj || "—"}</div>
        </div>
        <div class="field">
          <div class="field-label">Број личне карте</div>
          <div class="field-value ${!data?.broj_licne_karte ? 'empty' : ''}">${data?.broj_licne_karte || "—"}</div>
        </div>
        <div class="field">
          <div class="field-label">Датум рођења</div>
          <div class="field-value ${!data?.datum_rodjenja ? 'empty' : ''}">${formatDatum(data?.datum_rodjenja) || "—"}</div>
        </div>
        <div class="field">
          <div class="field-label">Адреса</div>
          <div class="field-value ${!data?.adresa ? 'empty' : ''}">${data?.adresa || "—"}</div>
        </div>
      </div>
    </div>

    <div>
      <div class="section-title">Контакт</div>
      <div class="grid">
        <div class="field">
          <div class="field-label">Телефон</div>
          <div class="field-value ${!data?.telefon ? 'empty' : ''}">${data?.telefon || "—"}</div>
        </div>
        <div class="field">
          <div class="field-label">Имејл</div>
          <div class="field-value ${!data?.email ? 'empty' : ''}">${data?.email || "—"}</div>
        </div>
      </div>
    </div>

    <div>
      <div class="section-title">Радно ангажовање</div>
      <div class="grid">
        <div class="field">
          <div class="field-label">Радно место</div>
          <div class="field-value ${!zaposlen?.radnoMesto ? 'empty' : ''}">${zaposlen?.radnoMesto || "—"}</div>
        </div>
        <div class="field">
          <div class="field-label">Пословна јединица</div>
          <div class="field-value ${!zaposlen?.poslovnaJedinica ? 'empty' : ''}">${zaposlen?.poslovnaJedinica || "—"}</div>
        </div>
        <div class="field">
          <div class="field-label">Почетак рада</div>
          <div class="field-value ${!data?.pocetak_rada ? 'empty' : ''}">${formatDatum(data?.pocetak_rada) || "—"}</div>
        </div>
        <div class="field">
          <div class="field-label">Статус</div>
          <div class="field-value">${data?.status_zaposlenog || "AKTIVAN"}</div>
        </div>
      </div>
    </div>

    <div>
      <div class="section-title">Квалификације и опрема</div>
      <div class="grid">
        <div class="field">
          <div class="field-label">Стручна спрема</div>
          <div class="field-value ${!data?.sprema_naziv ? 'empty' : ''}">${data?.sprema_naziv || "—"}</div>
        </div>
        <div class="field">
          <div class="field-label">Возачка дозвола</div>
          <div class="field-value ${!data?.vozacka_dozvola_naziv ? 'empty' : ''}">${data?.vozacka_dozvola_naziv || "—"}</div>
        </div>
        <div class="field">
          <div class="field-label">Величина одеће</div>
          <div class="field-value ${!data?.velicina_odece ? 'empty' : ''}">${data?.velicina_odece || "—"}</div>
        </div>
        <div class="field">
          <div class="field-label">Величина обуће</div>
          <div class="field-value ${!data?.velicina_obuce ? 'empty' : ''}">${data?.velicina_obuce || "—"}</div>
        </div>
      </div>
    </div>
  </div>

</div>
<script>window.onload = () => { window.print(); window.onafterprint = () => window.close(); }</script>
</body>
</html>`;

    const w = window.open("", "_blank", "width=900,height=700");
    w.document.write(html);
    w.document.close();
  };

  if (!data) return <div style={{ padding: "20px" }}>Учитавање...</div>;

  const fotoUrl = data?.slika ? `${baseUrl.replace("/api", "")}/${data.slika}` : null;

  const sections = [
    {
      title: "Лични подаци",
      fields: [
        ["Матични број", data.maticni_broj],
        ["Број личне карте", data.broj_licne_karte],
        ["Датум рођења", formatDatum(data.datum_rodjenja)],
        ["Адреса", data.adresa],
      ]
    },
    {
      title: "Контакт",
      fields: [
        ["Телефон", data.telefon],
        ["Имејл", data.email],
      ]
    },
    {
      title: "Радно ангажовање",
      fields: [
        ["Радно место", zaposlen?.radnoMesto],
        ["Пословна јединица", zaposlen?.poslovnaJedinica],
        ["Почетак рада", formatDatum(data.pocetak_rada)],
        ["Статус", data.status_zaposlenog],
      ]
    },
    {
      title: "Квалификације и опрема",
      fields: [
        ["Стручна спрема", data.sprema_naziv],
        ["Возачка дозвола", data.vozacka_dozvola_naziv],
        ["Величина одеће", data.velicina_odece],
        ["Величина обуће", data.velicina_obuce],
      ]
    }
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", padding: "20px", backgroundColor: "#f9f9f9", border: "1.5px solid #9f9f9f", overflow: "auto" }}>

      <div style={{ background: "white", maxWidth: "600px", margin: "0 auto", width: "100%", boxShadow: "0 2px 12px rgba(0,0,0,0.1)", border: "1px solid #111" }}>

        {/* Header */}
        <div style={{ background: "#fff", color: "#111", padding: "24px", display: "flex", gap: "20px", alignItems: "flex-end", borderBottom: "2px solid #111" }}>
          <div style={{ width: "75px", height: "95px", border: "1.5px solid #111", flexShrink: 0, overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", background: "#f5f5f5" }}>
            {fotoUrl
              ? <img src={fotoUrl} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              : <span style={{ color: "#aaa", fontSize: "10px", textAlign: "center", padding: "4px" }}>Нема фото</span>}
          </div>
          <div>
            <div style={{ fontSize: "9px", letterSpacing: "3px", color: "#666", marginBottom: "6px", textTransform: "uppercase" }}>Идентификациона картица запосленог</div>
            <div style={{ fontSize: "22px", fontWeight: 700, lineHeight: 1.1, color: "#111" }}>{data.ime} {data.prezime}</div>
            <div style={{ fontSize: "13px", color: "#444", marginTop: "4px" }}>{zaposlen?.radnoMesto || "—"}</div>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: "24px", display: "flex", flexDirection: "column", gap: "20px" }}>
          {sections.map((section) => (
            <div key={section.title}>
              <div style={{ fontSize: "9px", letterSpacing: "3px", textTransform: "uppercase", color: "#111", fontWeight: 700, borderBottom: "1.5px solid #111", paddingBottom: "5px", marginBottom: "12px" }}>
                {section.title}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 24px" }}>
                {section.fields.map(([label, value]) => (
                  <div key={label}>
                    <div style={{ fontSize: "9px", letterSpacing: "2px", textTransform: "uppercase", color: "#888", fontWeight: 600, marginBottom: "2px" }}>{label}</div>
                    <div style={{ fontSize: "13px", fontWeight: value ? 600 : 400, color: value ? "#111" : "#bbb", borderBottom: "1px solid #ddd", paddingBottom: "4px", fontStyle: value ? "normal" : "italic" }}>
                      {value || "—"}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Dugmad */}
      <div style={{ display: "flex", justifyContent: "space-between", maxWidth: "600px", width: "100%", margin: "16px auto 0" }}>
        <div onClick={handleZatvori}>
          <Button style={{ padding: "8px 20px", fontWeight: "bold" }}>НАЗАД</Button>
        </div>
        <div onClick={handlePrint}>
          <Button activation={true} style={{ padding: "8px 20px", fontWeight: "bold" }}>ШТАМПАЈ</Button>
        </div>
      </div>
    </div>
  );
}

export default IDKarticaZaposlen;